import {BehaviorSubject} from 'rxjs';

export function isBehaviourSubject<T>(o?: any): o is BehaviorSubject<T> {
    return o instanceof BehaviorSubject;
}
